var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.total_results > _vm.per_page)?_c('b-pagination',{staticClass:"m-0",attrs:{"pills":"","total-rows":_vm.total_results,"per-page":_vm.per_page,"disabled":_vm.loading},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }